import TemplateEmailModule from '@/modules/templateEmail';
import SubscriptionsModule from '@/modules/subscriptions';
import SupportMessagesModule from '@/modules/supportMessages';
import StatusOrderModule from '@/modules/statusOrder';
import OrdersModule from '@/modules/orders';
import PagesModule from '@/modules/pages';
import AdminModule from '@/modules/admin';
import ProductModule from '@/modules/products';
import CategoriesModule from '@/modules/categories';
import OffersModule from '@/modules/offers';
import SettingModule from '@/modules/spacesSetting';
import StatisticsModule from '@/modules/statistics';

export default {
  TemplateEmail: {
    exact: false,
    path: '/template-email',
    component: TemplateEmailModule
  },
  StatisticsModule: {
    exact: false,
    path: '/admin/statistics',
    component: StatisticsModule
  },
  Subscriptions: {
    exact: false,
    path: '/subscriptions',
    component: SubscriptionsModule
  },
  SupportMessages: {
    exact: false,
    path: '/supportmessages',
    component: SupportMessagesModule
  },
  StatusOrder: {
    exact: false,
    path: '/status-orders',
    component: StatusOrderModule
  },
  Orders: {
    exact: false,
    path: '/orders',
    component: OrdersModule
  },
  Pages: {
    exact: false,
    path: '/pages',
    component: PagesModule
  },
  User: {
    exact: false,
    path: '/admin',
    component: AdminModule
  },
  Product: {
    exact: false,
    path: '/products',
    component: ProductModule
  },
  Category: {
    exact: false,
    path: '/categories',
    component: CategoriesModule
  },
  Offers: {
    exact: false,
    path: '/offers',
    component: OffersModule
  },
  Settings: {
    exact: true,
    path: '/setting/:id',
    component: SettingModule
  }

};
